import { Outlet } from 'react-router-dom';

import { SiteFooter } from '@/components/site-footer';
import { SiteHeader } from '@/components/site-header';

/** Casca do site público: cabeçalho fixo, conteúdo e rodapé. */
export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      {/*
        Primeiro elemento focável da página, invisível até receber foco. Sem ele
        quem navega por teclado atravessa os cinco itens do menu a cada carga.
        Vinha do protótipo e tinha se perdido na portagem.
      */}
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-[100] focus:bg-brand-600 focus:px-4 focus:py-3 focus:text-sm focus:text-bone"
      >
        Ir para o conteúdo
      </a>

      <SiteHeader />

      <main id="conteudo" className="flex-1">
        <Outlet />
      </main>

      <SiteFooter />
    </div>
  );
}
